import React, { useEffect, useState } from "react";
import { Row, Col, Form, Container } from "react-bootstrap";
import { connect } from "react-redux";
import { JobReportApi, GetJobWithIdApi, UpdateJobStatusApi, ClearJobReport, DocumentStatusReportPDFApi } from "./JobAction";
import { setHeading } from "../../../accounts/account.actions";
import { GetCRMProductApi } from "../CRMProducts/CRMProductAction";
import { GetCRMCustomerApi } from "../CRMCustomer/CustomerActionCRM";
import { GetTeamMemberApi } from "../TeamMember/TeamMemberAction";
import { useNavigate, useLocation } from "react-router-dom";
import _ from "lodash";
import Spinner from "react-bootstrap/Spinner";
import SendIcon from '@mui/icons-material/Send';
import ClearIcon from '@mui/icons-material/Clear';
import Button from '@mui/material/Button';
import Select from "react-select";
import MaterialSize from "material-table";
import UploadFileIcon from '@mui/icons-material/UploadFile';
import VisibilityIcon from '@mui/icons-material/Visibility';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
const tableRef = React.createRef()


const JobReport = (props) => {
    const permissions = JSON.parse(window.localStorage.getItem("permissions"));
    const Checkpermissions = (permissionsType, permissionsName) => {
        return permissions.some((p) => p[`${permissionsType}`] === permissionsName) ? false : true;
    };
    const navigate = useNavigate();
    const location = useLocation();
    const [productId, setProductId] = useState([]);
    const [productName, setProductName] = useState([]);
    const [customerId, setCustomerId] = useState([]);
    const [customerName, setCustomerName] = useState([]);
    const [teamMemberId, setTeamMemberId] = useState([]);
    const [teamMemberName, setTeamMemberName] = useState([]);
    const [jobStatus, setJobStatus] = useState("");
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [show, setShow] = useState(false);

    function SearchJob() {
        props.JobReportApi({
            productId: productId,
            productName: productName,
            customerId: customerId,
            customerName: customerName,
            teamMemberId: teamMemberId,
            teamMemberName: teamMemberName,
            jobStatus: jobStatus,
            startDate: startDate,
            endDate: endDate,
        });
        setShow(true);
    }
    function handleClear() {
        setProductId([]);
        setProductName([]);
        setCustomerId([]);
        setCustomerName([]);
        setTeamMemberId([]);
        setTeamMemberName([]);
        setJobStatus("");
        setStartDate("");
        setEndDate("");
        setShow(false);
        props.ClearJobReport();
        if (tableRef.current) {
            tableRef.current.onQueryChange();
        }
    }
    function DocumentStatusReport() {
        props.DocumentStatusReportPDFApi({
            productId: productId,
            productName: productName,
            customerId: customerId,
            customerName: customerName,
        });
    }

    const jobStatusList = [
        { value: "In Progress", label: "In Progress" },
        { value: "Completed", label: "Completed" },
        { value: "Not Sure", label: "Not Sure" },
        { value: "Not Accepted", label: "Not Accepted" },
    ]
    const handleChangeJobStatus = (selectedOption) => {
        setJobStatus(selectedOption?.label || "");
    };

    const handleChangeProduct = (selectedOption) => {
        setProductId(selectedOption.map(obj => obj.value));
        setProductName(selectedOption.map(obj => obj.label));
    };
    const getProductList = props.CRMProductList?.length ? props.CRMProductList.map(x => ({
        value: x._id,
        label: x.productName
    })) : [];

    const handleChangeCustomer = (selectedOption) => {
        setCustomerId(selectedOption.map(obj => obj.value));
        setCustomerName(selectedOption.map(obj => obj.label));
    };
    const getCustomerList = props.CRMCustomerList?.length ? props.CRMCustomerList.map(x => ({
        value: x._id,
        label: x.companyName,
    })) : [];

    const handleChangeTeamMember = (selectedOption) => {
        setTeamMemberId(selectedOption.map(obj => obj.value));
        setTeamMemberName(selectedOption.map(obj => obj.label));
    };
    const getTeamMemberList = props.teamMemberList?.length ? props.teamMemberList.map(x => ({
        value: x._id,
        label: x.name,
    })) : [];

    useEffect(() => {
        props.setHeading("Job Report");
        props.GetCRMProductApi();
        props.GetCRMCustomerApi();
        props.GetTeamMemberApi();
        return () => {
            props.ClearJobReport();
        };
    }, []);

    return (
        <>
            {props.isFetchingCRMProduct || props.isFetchingTeamMember || props.isFetchingCRMCustomer ? (
                <div className="loader-div">
                    <Spinner
                        variant="primary"
                        animation="border"
                        size="xl"
                        role="status"
                        aria-hidden="true"
                    />
                </div>
            ) : (
                <Container fluid>
                    <Form>
                        <Row>
                            <Col>
                                <Form.Group className="mb-3" controlId="garana">
                                    <Form.Label><b>Select Sevice *</b></Form.Label>
                                    <Select
                                        placeholder="Select Sevice"
                                        onChange={handleChangeProduct}
                                        options={getProductList}
                                        isMulti={true}
                                        value={productId.length ? getProductList.filter(opt => productId.includes(opt.value)) : []}
                                    />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="garana">
                                    <Form.Label><b>Select Client *</b></Form.Label>
                                    <Select
                                        placeholder="Select Client"
                                        onChange={handleChangeCustomer}
                                        options={getCustomerList}
                                        noOptionsMessage={() => "No clients found"}
                                        isMulti={true}
                                        value={customerId.length ? getCustomerList.filter(opt => customerId.includes(opt.value)) : []}
                                    />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="garana">
                                    <Form.Label><b>Select Team Member *</b></Form.Label>
                                    <Select
                                        placeholder="Select Team Member"
                                        onChange={handleChangeTeamMember}
                                        options={getTeamMemberList}
                                        isMulti={true}
                                        value={teamMemberId.length ? getTeamMemberList.filter(opt => teamMemberId.includes(opt.value)) : []}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Group className="mb-3" controlId="garana">
                                    <Form.Label><b>Select Status *</b></Form.Label>
                                    <Select
                                        placeholder="Select Status"
                                        onChange={handleChangeJobStatus}
                                        options={jobStatusList}
                                        value={jobStatus ? { value: jobStatus, label: jobStatus } : null}
                                    />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="garana">
                                    <Form.Label><b>Start Date *</b></Form.Label>
                                    <Form.Control
                                        type="date"
                                        placeholder="Start Date"
                                        onChange={(e) => setStartDate(e.target.value)}
                                        value={startDate}
                                    />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="garana">
                                    <Form.Label><b>End Date *</b></Form.Label>
                                    <Form.Control
                                        type="date"
                                        placeholder="End Date"
                                        onChange={(e) => setEndDate(e.target.value)}
                                        value={endDate}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        <div className="sendDiv">
                            {_.isEmpty(productId) ? (
                                <Button variant="contained" endIcon={<SendIcon />} size="large" disabled> Documents Status Report </Button>
                            ) : (
                                <Button variant="contained" endIcon={<SendIcon />} size="large" onClick={DocumentStatusReport}> Documents Status Report </Button>
                            )}
                            <Button variant="contained" style={{ marginLeft: '20px', }} endIcon={<SendIcon />} size="large" onClick={SearchJob}> SEARCH </Button>
                            <Button variant="contained" style={{ marginLeft: '20px', backgroundColor: '#b91515' }} endIcon={<ClearIcon />} size="large" onClick={handleClear}> CLEAR </Button>
                        </div>

                        <div>
                            {show &&
                                <MaterialSize
                                    title="Job Report"
                                    tableRef={tableRef}
                                    columns={[
                                        { title: 'Sequence Number', field: 'sequenceNumber', editable: 'never' },
                                        { title: "Client", field: "customerId.companyName", editable: 'never' },
                                        { title: "Service", field: "productId.productName", editable: 'never' },
                                        { title: "Team Member", field: "teamMemberId.name", editable: 'never' },
                                        { title: "Job Status", field: "jobStatus", editable: 'never' },
                                        { title: "Start Date", field: "startDate" },
                                        { title: "End Date", field: "endDate" },
                                        { title: "Invoice Number", field: "invoiceNumber" },
                                        { title: "Financial Year", field: "financialYear" },
                                        { title: "Financial Month", field: "financialMonth" },
                                        { title: "Fee", field: "fee" },
                                        { title: "VAT", field: "vat" },
                                        { title: "Job Fee", field: "jobFee" },
                                        {
                                            title: "Fee Status", field: "feeStatus", editable: 'never',
                                            render: (rowData) => (
                                                <div
                                                    style={{
                                                        backgroundColor: rowData.feeStatus === "Paid" ? "#9FD983" : rowData.feeStatus === "UnPaid" ? "#F8B8A2" : "#F8B8A2",
                                                        padding: "5px 16px 7px",
                                                        borderRadius: "10px",
                                                        textAlign: "center",
                                                        width: "max-content"
                                                    }}
                                                >
                                                    {rowData.feeStatus}
                                                </div>
                                            ),
                                        },
                                        { title: "Created By", field: "userDetails.userName", editable: 'never' },
                                    ]}
                                    data={props.jobReport}
                                    options={{
                                        actionsColumnIndex: -1,
                                        exportButton: true,
                                        exportAllData: true,
                                        paging: true,
                                        pageSize: 50,
                                        emptyRowsWhenPaging: false,
                                        pageSizeOptions: [50, 100, 150, 200],
                                        headerStyle: {
                                            position: "sticky",
                                            top: 0,
                                            color: "#00BBBB",
                                            fontWeight: "550",
                                            onRowAdd: "none",
                                        },
                                    }}
                                    actions={[
                                        (rowData) => ({
                                            icon: () => <UploadFileIcon />,
                                            tooltip: "Upload Documents",
                                            onClick: async (event, rowData) => {
                                                navigate(`/crm/job/UploadDocument/${rowData._id}`);
                                                props.GetJobWithIdApi(rowData._id)
                                            },
                                        }),
                                        (rowData) => ({
                                            hidden: Checkpermissions("permissionsSubCatName", "Upload Job Document"),
                                            icon: () => <VisibilityIcon />,
                                            tooltip: "Job Preview",
                                            onClick: (event, rowData) => {
                                                navigate("/crm/job/DetailJobView", {
                                                    state: {
                                                        fromPath: location.pathname,
                                                        JobViewDetails: rowData,
                                                    },
                                                });
                                            },
                                        }),
                                        (rowData) => ({
                                            // hidden: Checkpermissions("permissionsSubCatName", "Voucher Approvel Permission") === true ? false : true,
                                            disabled: rowData.feeStatus === 'UnPaid' ? false : true,
                                            icon: () => <TaskAltIcon style={{ color: rowData.feeStatus === 'UnPaid' ? 'green' : '#cccccc' }} />,
                                            tooltip: "Fee Paid",
                                            onClick: (event, rowData) => {
                                                const status = 'Paid'
                                                props.UpdateJobStatusApi(rowData._id, status);
                                                tableRef.current && tableRef.current.onQueryChange();
                                            },
                                        }),
                                    ]}
                                />
                            }
                        </div>

                    </Form>
                </Container>
            )}
        </>
    );
};

const mapDispatchToProps = (dispatch) => {
    return {
        JobReportApi: (data) => dispatch(JobReportApi(data)),
        DocumentStatusReportPDFApi: (data) => dispatch(DocumentStatusReportPDFApi(data)),
        GetCRMProductApi: () => dispatch(GetCRMProductApi()),
        GetCRMCustomerApi: () => dispatch(GetCRMCustomerApi()),
        GetTeamMemberApi: () => dispatch(GetTeamMemberApi()),
        UpdateJobStatusApi: (jobId, status) => dispatch(UpdateJobStatusApi(jobId, status)),
        GetJobWithIdApi: (id) => dispatch(GetJobWithIdApi(id)),
        ClearJobReport: () => dispatch(ClearJobReport()),
        setHeading: (data) => dispatch(setHeading(data)),
    };
};

const mapStateToProps = (state, ownProps) => ({
    isFetchingCRMProduct: state.CRMProductReducer.isFetchingCRMProduct,
    CRMProductList: state.CRMProductReducer.CRMProductList,
    isFetchingCRMCustomer: state.CustomerReducerCRM.isFetchingCRMCustomer,
    CRMCustomerList: state.CustomerReducerCRM.CRMCustomerList,
    isFetchingTeamMember: state.TeamMemberReducer.isFetchingTeamMember,
    teamMemberList: state.TeamMemberReducer.teamMemberList,
    jobReport: state.JobReducer.jobReport,
});

export default connect(mapStateToProps, mapDispatchToProps)(JobReport);